import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

declare let jQuery: any;

@Component({
  selector: 'blank',
  templateUrl: 'blank.component.html',
  standalone: true,
  imports: [RouterOutlet]
})
export class BlankComponent implements AfterViewInit, OnDestroy {
  ngAfterViewInit() {
    jQuery('body').addClass('gray-bg');
  }

  ngOnDestroy() {
    jQuery('body').removeClass('gray-bg');
  }
}
